export const blockIconsHouseholdSensorsNew = (
	<span className='material-symbols-outlined'>sensors</span>
);
